import { ChevronDownIcon } from 'components/icons';
import { StatusTag, Tooltip } from 'components/ui';
import { PAID_PLAN_TOOLTIP } from 'config.js';
import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useStoreSubscriptionPlan } from 'utils/useStoreSubscriptionPlan';

/**
 * Submenus Navigation Links with Active Link highlight
 * @param {{
 * mainMenu: string | React.ReactNode,
 * subMenus:{pathname:string,search:string, name:string, subscriptionAccess?:number, newFeature?:boolean, callback?:Function}[],
 * icon:import('react').ReactNode,
 * fullSize:boolean,
 * newFeature?:boolean,
 *   iconsColor?: 'white' | "black",
 * }} param0
 * @returns
 */
export default function NavigationLinkMultiMenu({
  mainMenu,
  subMenus,
  icon: Icon,
  fullSize,
  newFeature = false,
  iconsColor = 'white',
}) {
  const [subMenuOpen, setSubMenuOpen] = useState(false);
  const justifyIcon = fullSize ? 'justify-start' : 'justify-center';

  return (
    <div
      className="px-4 py-3 text-base font-bold rounded-lg cursor-pointer 2xl:py-4 hover:bg-white hover:bg-opacity-10 "
      onClick={(e) => setSubMenuOpen(!subMenuOpen)}
    >
      <div className={`flex items-center space-x-4 ${justifyIcon}`}>
        {/* @ts-ignore */}
        <Icon
          className={`w-6 h-6 ${
            iconsColor === 'white' ? 'text-white' : 'text-black'
          }`}
        />
        {fullSize && (
          <div className="flex items-center justify-between w-full pl-1 pr-2.5">
            <div className="flex items-center space-x-1.5">
              <p className="truncate">{mainMenu}</p>
              {newFeature && (
                <div className="w-2 h-2 rounded-full bg-segments-accent-color-orange" />
              )}
            </div>
            <span>
              <ChevronDownIcon
                className={`w-4 h-4 ${
                  iconsColor === 'white' ? 'text-white' : 'text-black'
                }`}
              />
            </span>
          </div>
        )}
      </div>
      {subMenuOpen && (
        <ul className="flex flex-col justify-center mt-4 text-sm leading-4">
          {subMenus.map((menu) => (
            <SubMenuItem menu={menu} key={menu.pathname} />
          ))}
        </ul>
      )}
    </div>
  );
}

/**
 * Internal Component only - Individual submenu items
 * @param {{menu:{pathname:string, search:string, name:string, subscriptionAccess?:number, newFeature?:boolean, callback?:Function}}} param0
 */
function SubMenuItem({ menu }) {
  const location = useLocation();

  const {
    storeSubscriptionPlan,
    subscriptionPlans,
  } = useStoreSubscriptionPlan();

  const isSubscriptionDisabled =
    (menu.subscriptionAccess || 0) > storeSubscriptionPlan;

  return (
    <Tooltip
      text={PAID_PLAN_TOOLTIP}
      disabled={(menu.subscriptionAccess || 0) <= storeSubscriptionPlan}
    >
      <Link
        className={`flex items-center justify-between py-3 rounded-lg hover:bg-white pl-14 ${
          isSubscriptionDisabled
            ? 'cursor-not-allowed hover:bg-opacity-5'
            : 'hover:bg-opacity-10'
        }`}
        to={{
          pathname: !!!isSubscriptionDisabled ? menu.pathname : '',
          search: !!!isSubscriptionDisabled ? menu.search : '',
        }}
        onClick={(e) => {
          e.stopPropagation();
          if (isSubscriptionDisabled) {
            e.preventDefault();
            return;
          }
          if (menu.callback) {
            menu.callback();
          }
        }}
      >
        <div className={`${isSubscriptionDisabled && 'opacity-50'}`}>
          <p>{menu.name}</p>

          {menu.newFeature && (
            <div className="text-xs font-light text-segments-accent-color-orange">
              New Feature
            </div>
          )}
        </div>

        {isSubscriptionDisabled && (
          <div className="pr-2 font-normal">
            <StatusTag variant="main">
              {(menu.subscriptionAccess || 0) < subscriptionPlans.growth
                ? 'Paid'
                : 'Growth+'}
            </StatusTag>
          </div>
        )}

        {location.pathname === menu.pathname && (
          <div className="absolute right-0 w-1 h-7 bg-segments-accent-color-orange rounded-l-md" />
        )}
      </Link>
    </Tooltip>
  );
}
